import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { newsService } from '@/services/news';

export function useNewsList() {
    const crudAction = useCrudActions();

    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const { list, total, fetchList } = useBaseListView({
        request: newsService.list,
        paramsBuilder: () => ({ ...query }),
        hooks: {
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute
        }
    });

    const actions = {
        enable: crudAction.confirmAndEnable({
            request: newsService.enable,
            onSuccess: () => fetchList()
        }),
        disable: crudAction.confirmAndDisable({
            request: newsService.disable,
            onSuccess: () => fetchList()
        }),
        remove: crudAction.confirmAndRemove({
            request: newsService.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, query, fetchList, actions };
}
